import Cargos from '@/models/Cargos'

export default [
  {
    path: '/administrativo/descontos',
    name: 'rota-descontos',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Descontos',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Descontos',
      icon: 'percent',
    },
    component: () => import(/* webpackChunkName: "descontos" */ '../views/descontos/Descontos.vue'),
  },
]
